import { ArrowRight } from "lucide-react";
import { Eyebrow, IconChip, SectionHeader, FadeIn } from "./primitives";
import { practiceCards } from "@/data/dashboard";
import { toast } from "@/components/ui/sonner";

const PracticeCard = ({ icon, title, desc, onClick, testId }) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    className="group relative flex h-full min-h-[148px] flex-col rounded-xl border border-border bg-card p-4 text-left shadow-soft transition-colors duration-200 hover:border-border-strong hover:bg-card-hover focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
  >
    <IconChip icon={icon} />
    <div className="mt-auto flex items-end justify-between gap-2 pt-6">
      <div className="min-w-0">
        <h3 className="text-[15px] font-medium text-foreground">{title}</h3>
        <p className="mt-0.5 text-[13px] leading-snug text-muted-foreground">{desc}</p>
      </div>
      <ArrowRight className="mb-0.5 h-4 w-4 shrink-0 text-muted-foreground transition-all duration-200 group-hover:translate-x-0.5 group-hover:text-primary" />
    </div>
  </button>
);

export const DailyPractice = () => {
  const open = (title) =>
    toast(`Opening ${title}`, { description: "This is a design prototype." });

  return (
    <FadeIn>
      <section>
        <SectionHeader
          eyebrow="Daily Practice"
          title="Inventory and gratitude"
          caption="The tools most people come back to every day."
        />
        <div className="grid grid-cols-2 gap-3 sm:gap-4 lg:grid-cols-4">
          {practiceCards.map((c) => (
            <PracticeCard
              key={c.id}
              icon={c.icon}
              title={c.title}
              desc={c.desc}
              onClick={() => open(c.title)}
              testId={`practice-${c.id}`}
            />
          ))}
        </div>
      </section>
    </FadeIn>
  );
};
